import { GetItemAuthenticityModalArgs } from 'types/api/arguments/get-item-authenticity-modal-args'
import { ItemAuthenticityModalResp } from 'types/api/response/item-authenticity-modal-resp'

import { api } from './api'

export const getItemAuthenticityModal = ({
  catalogId,
  itemId,
  force = false,
  modalDataOnly = false,
}: GetItemAuthenticityModalArgs) =>
  api.get<ItemAuthenticityModalResp>('/items/authenticity_modals', {
    params: {
      catalog_id: catalogId,
      force,
      item_id: itemId,
      modal_data_only: modalDataOnly,
    },
  })
